import ApplicationSchema from 'src/configs/APISchemas/Application.schema';
import {
  SET_COMPLIANCE_ERROR,
  SET_COVIE_DATA,
  UPDATE_APPLICATION,
  UPDATE_APPLICATION_ROUTE,
} from '../contants';

export const UpdateApplication = (
  data: ApplicationSchema | Record<string, unknown>,
): SchemaReturnType => {
  return {
    type: UPDATE_APPLICATION,
    payload: data,
  };
};

export const UpdateApplicationRoute = (route: string): SchemaReturnType => {
  return {
    type: UPDATE_APPLICATION_ROUTE,
    payload: route,
  };
};
export const UpdateCovieData = (payload: any): SchemaReturnType => {
  return {
    type: SET_COVIE_DATA,
    payload,
  };
};

export const UpdateComplianceErrors = (payload: any): SchemaReturnType => {
  return {
    type: SET_COMPLIANCE_ERROR,
    payload,
  };
};

export interface SchemaReturnType {
  type: string;
  payload: any;
}
